module.exports = {
  fetch: `query getAvatars {
    avatars {
      id
      key
      name {
        en
        es
      }
      picture {
        url
      }
      pollyVoiceId {
        en
        es
      }
      pollyEngine {
        en
        es
      }
      avatarOptions {
        upperUnderwear
        bodyType
        genderType
        defaultOutfit,
        defaultIslamicOutfit
      }
    }
  }`,
};
